export function esAlfanumerico(value: string) {
  return /[a-z0-9\sáéíóúñ.,_\-&/]/i.test(value);
}

export function esSoloLetras(value: string) {
  return /^[a-zA-Z]*$/.test(value);
}

export function esSoloLetrasNumeros(value: string) {
  return /^[a-zA-Z0-9]*$/.test(value);
}

export function esEmail(value: string) {
  if (!value || value !== value.trim()) return false;

  for (const character of value) {
    if (!character.trim()) return false;
  }

  const arrobaIndex = value.indexOf('@');
  if (arrobaIndex <= 0 || arrobaIndex !== value.lastIndexOf('@')) return false;

  const dominio = value.slice(arrobaIndex + 1);
  const puntoIndex = dominio.indexOf('.');
  return puntoIndex > 0 && puntoIndex < dominio.length - 1;
}
